




































































/** @format */

import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@/utils/common';
// import PlateInput from '../../../components/plate-input/index.vue'
// 导入字典
import {
  dictoperationTypeMap,
  dictIssuedOpinionMap,
  dictopOpinionMap
} from '@/types/special-authorized-car-management/dictionaries';

// axios请求
import { getpageList } from '@/api/discount-management/index';

@Component({
  name: 'PackagePurchaseRecord',
  components: {
    ParkingLotSearch
  }
})
export default class PackagePurchaseRecord extends Mixins(TableMixin, TableWidthMixin) {
  @Prop()
  id!: any;

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '套餐名称',
        dataIndex: 'packageName',
        width: 190,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '优惠类型',
        dataIndex: 'packageTypeName',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      // {
      //   title: '结算价（元）',
      //   dataIndex: 'authTypeName',
      //   width: 190,
      //   // customRender: (text: any) => text || '--',
      //   scopedSlots: { customRender: 'text-ellipse' },
      // },
      {
        title: '套餐数额',
        dataIndex: 'totalBuyAmount',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '套餐已发放',
        dataIndex: 'totalSendAmount',
        width: 240,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any) => text || '--'
      },

      {
        title: '套餐余额',
        dataIndex: 'restQuota',
        width: 110,
        // customRender: (text: any) => dictAlonePayMap[text],
        customRender: (text: any) => text || '--'
      },
      {
        title: '套餐已失效',
        dataIndex: 'totalInvalidAmount',
        width: 140,
        // scopedSlots: { customRender: 'authStatus' },
        // customRender: (text: any) => dictAuthorizationStatusTypeMap[text],

        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠失效期',
        dataIndex: 'expirationDate',
        width: 240,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any) => text || '--'
      },
      {
        title: '购买方式',
        dataIndex: 'buyTypeName',
        width: 240,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any) => text || '--'
      },
      {
        title: '购买时间',
        dataIndex: 'buyDate',
        width: 240,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any) => text || '--'
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 180,
        // scopedSlots: { customRender: 'status' },
        customRender: (text: any) => text || '--'
      }
    ];
  }

  // currPage = 1
  // pageSize = 10
  current = 1;
  pageSize = 10;
  tableData = [];
  /**
   * 生命周期钩子函数
   */
  created() {
    // 特殊车辆类型列表初始化
    this.fetchTableData();
  }

  /**
   * 请求列表数据
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    // @ts-ignore
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const res = await getpageList({
        merchantId: this.id,
        currPage: this.current,
        pageSize: this.pageSize
      });
      console.log(res);
      const { data } = res;
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = data.datas;
      this.total = totalNum - 0;
      // this.current = currPage - 0
      // this.pageSize = pageSize - 0
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      // @ts-ignore
      this.tableLoading = false;
    }
  }
}
